import { useEffect } from 'react'
import { useParams, Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NAVIGATION_LOCALES, NAVIGATION_DEFAULT_LOCALE } from 'src/types/locales'

export const LocaleWrapper = () => {
  const { locale } = useParams<{ locale: string }>()
  const { i18n } = useTranslation()
  const location = useLocation()

  // Change i18n language when locale param changes
  useEffect(() => {
    if (locale && locale !== i18n.language) {
      i18n.changeLanguage(locale)
    }
  }, [locale, i18n])

  // If no locale in URL, redirect to default locale
  if (!locale) {
    // Preserve the rest of the path
    const newPath = `/${NAVIGATION_DEFAULT_LOCALE}${location.pathname}${location.search}`
    return <Navigate to={newPath} replace />
  }

  // If invalid locale, redirect to default locale
  if (!NAVIGATION_LOCALES.includes(locale as any)) {
    const newPath = location.pathname.replace(`/${locale}`, `/${NAVIGATION_DEFAULT_LOCALE}`)
    return <Navigate to={newPath} replace />
  }

  return <Outlet />
}
